<template>
  <div class="Challenge">
    <div id="form-div">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-10">
          {{ $t('wheelAnalysis.challenge.prompt') }}
          <MDBTextarea
              :disabled="!editMode"
              :label="$t('wheelAnalysis.challenge.textareaLabel')"
              rows="8"
              v-model="challengeStatement"
              @blur="challengeStore.challengeStatementChanged"
          />
        </div>
      </div>

      <br />
      <br />

      <div class="sidebar-instructions px-4">
        {{ $t('wheelAnalysis.challenge.guidanceNote') }}
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_ChallengeStatement.js" lang="js"></script>
<style src="./_ChallengeStatement.less" lang="less" scoped></style>
